import { useEffect } from 'react';
import styles from './CallRecordingDisabledTooltip.module.css'; // Import your custom styles
import CallRecordingDisabledIcon from "../../../src/Assets/Images/callRecordingDisabled.png";
import { IoIosClose } from "react-icons/io";

const Tooltip = ({ showTooltip, setShowTooltip }: any) => {

    useEffect(() => {
        if (showTooltip) {
            const timer = setTimeout(() => {
                setShowTooltip(false);
            }, 2000);

            // Cleanup the timer when the component unmounts or the effect re-runs
            return () => clearTimeout(timer);
        }
    }, [showTooltip]);  // Add showTooltip to dependency array

    return (
        <>
            {
                showTooltip && (
                    <div className={styles.tooltipContainer}>
                        <div className={styles.tooltipIcon}>
                            <img src={CallRecordingDisabledIcon} alt="call recording disabled" />
                        </div>
                        <div className={styles.tooltipContent}>
                            <p>Call recording feature is disabled due to pack expiry.</p>
                            <small>To renew, contact your account manager</small>
                        </div>
                        <div className={styles.cross}
                            onClick={() => {
                                setShowTooltip(false)
                            }}
                        >
                            <IoIosClose size={35} color={"#fff"} />
                        </div>
                    </div>
                )
            }
        </>
    );
};

export default Tooltip;
